import React from 'react';
import { NoticeModel } from '../../../../models';
import { ArrowLeft, Calendar, User, Eye, Pin } from 'lucide-react';

interface StudentNoticeDetailViewProps {
    notice: NoticeModel;
    onBack: () => void;
}

const StudentNoticeDetailView: React.FC<StudentNoticeDetailViewProps> = ({ notice, onBack }) => {
    return (
        <div className="animate-in fade-in slide-in-from-right duration-300 space-y-6">
            <button
                onClick={onBack}
                className="flex items-center space-x-2 text-slate-500 hover:text-indigo-600 transition-colors group"
            >
                <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                <span className="text-sm font-bold">목록으로 돌아가기</span>
            </button>

            <div className="bg-white rounded-[2rem] shadow-sm border border-slate-100 overflow-hidden">
                <div className="p-8 sm:p-10 border-b border-slate-50">
                    <div className="flex flex-wrap items-center gap-2 mb-4">
                        {notice.isPinned && (
                            <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-[10px] font-black flex items-center">
                                <Pin size={10} className="mr-1 fill-current" />
                                중요공지
                            </span>
                        )}
                        <span className={`px-3 py-1 rounded-full text-[10px] font-black ${notice.category === '중요' ? 'bg-rose-100 text-rose-700' :
                            notice.category === '학습' ? 'bg-emerald-100 text-emerald-700' :
                                notice.category === '지점' ? 'bg-amber-100 text-amber-700' :
                                    'bg-slate-100 text-slate-700'
                            }`}>
                            {notice.category}
                        </span>
                    </div>
                    <h1 className="text-2xl sm:text-3xl font-black text-slate-900 leading-tight mb-6">
                        {notice.title}
                    </h1>
                    <div className="flex flex-wrap items-center gap-5 text-xs text-slate-400 font-bold">
                        <div className="flex items-center gap-1.5">
                            <User size={14} className="text-slate-300" />
                            <span>{notice.authorName}</span>
                        </div>
                        <div className="flex items-center gap-1.5">
                            <Calendar size={14} className="text-slate-300" />
                            <span>{new Date(notice.createdAt).toLocaleDateString()}</span>
                        </div>
                        <div className="flex items-center gap-1.5">
                            <Eye size={14} className="text-slate-300" />
                            <span>조회 {notice.viewCount}</span>
                        </div>
                    </div>
                </div>
                <div className="p-8 sm:p-10">
                    <div
                        className="prose prose-slate max-w-none text-slate-600 leading-relaxed
                            prose-headings:font-black prose-headings:text-slate-900
                            prose-p:mb-4 prose-strong:text-indigo-600
                            prose-img:rounded-2xl prose-img:shadow-md
                            prose-a:text-indigo-600 prose-a:font-bold prose-a:no-underline hover:prose-a:underline"
                        dangerouslySetInnerHTML={{ __html: notice.content }}
                    />
                </div>
            </div>
        </div>
    );
};

export default StudentNoticeDetailView;
